import { render, staticRenderFns } from "./CategoryCard.vue?vue&type=template&id=4bbc6c2a&scoped=true&"
import script from "./CategoryCard.vue?vue&type=script&lang=js&"
export * from "./CategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCard.vue?vue&type=style&index=0&id=4bbc6c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbc6c2a",
  null
  
)

export default component.exports